import PropTypes from 'prop-types';
import React from 'react';
import {FmlxIcon} from 'fmlx-common-ui';
import './MessageContainer.scss';

const MESSAGE_TYPE = {
  WARNING: 'Warning',
  ERROR: 'Error',
  INFO: 'Info',
};

const MessageContainer = React.memo((props) => {
  const {children, messageType} = props;

  return (
    <div className={`message-container message-container__message-${messageType}`}>
      <div className="message-container-icon">
        {messageType === MESSAGE_TYPE.WARNING && <FmlxIcon name="Warning" size="xs" customColor="red" />}
        {messageType === MESSAGE_TYPE.ERROR && <FmlxIcon name="Warning" size="xs" customColor="#db0000" />}
        {messageType === MESSAGE_TYPE.INFO && <FmlxIcon name="remove-sign" size="xs" customColor="blue" />}
      </div>
      <div className="message-container-text">{children}</div>
    </div>
  );
});

MessageContainer.MessageType = MESSAGE_TYPE;

MessageContainer.propTypes = {
  messageType: PropTypes.string,
  children: PropTypes.any,
};

MessageContainer.defaultProps = {
  messageType: MESSAGE_TYPE.WARNING,
  // eslint-disable-next-line react/jsx-no-useless-fragment
  children: <></>,
};

export default MessageContainer;
